import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthguardService } from './authguard.service';
import { UserStorage } from './userStorage';

@Injectable()
export class Authguard implements CanActivate {
  constructor(
    private authguardService: AuthguardService,
    private router: Router,
    private user: UserStorage
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    const userRole: number = this.user.getLocalUserRole();

    // check basic current user state
    if (!userRole || userRole < 0) {
      this.router.navigate(['/'], { queryParams: { returnUrl: state.url }});
      return false;
    }

  //   this.verifyJwt().then(validJwt => {
  //     if (!validJwt) {
  //       this.user.signOut();
  //       this.router.navigate(['/'], { queryParams: { returnUrl: state.url }});
  //       return false;
  //     }

  //     // without permission, the view should be accessed by everyone
  //     const permission = route.data.permission;
  //     if (!permission) {
  //       return true;
  //     }

  //     // check role
  //     const roleAllowed = route.data.permission.role;
  //     if (!roleAllowed || userRole < roleAllowed) {
  //       this.router.navigate([route.data.permission.redirectTo]);
  //       return false;
  //     }

  //     return true;
  //  });

    // without permission, the view should be accessed by everyone
    const permission = route.data.permission;
    if (!permission) {
      return true;
    }

    // check role
    const roleAllowed = route.data.permission.role;
    // if (!roleAllowed || userRole < roleAllowed) {
    //   this.router.navigate([route.data.permission.redirectTo]);
    //   return false;
    // }
    if(!roleAllowed || !roleAllowed.includes(userRole)) {
      this.router.navigate([route.data.permission.redirectTo]);
      return false;
    }

    return true;
  }

  // public verifyJwt() {
  //   return new Promise(resolve => {
  //     this.authguardService.verifyJwt()
  //       .subscribe((data: any) => {
  //         if (data === true) {
  //           return resolve(true);
  //         } else {
  //           return resolve(false);
  //         }
  //       }, err => {
  //         return resolve(false);
  //       });
  //   });
  // }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/helper/authguard.ts